<template>
  <div class="flex flex-grow flex-wrap justify-between mt-2">
    <CButton
      v-if="hasCancel"
      :bordered="false"
      :disabled="disableCancelWhenLoading && isLoading"
      type="default"
      @click="emit('cancel')"
    >
      {{ cancelText ?? t('canvasUI.common.cancel') }}
    </CButton>

    <div class="flex gap-2 ml-auto">
      <CButton
        v-if="hasExit"
        :bordered="false"
        :disabled="disableDenyWhenLoading && isLoading"
        type="default"
        @click="emit('exit')"
      >
        {{ exitText ?? t('canvasUI.common.deny') }}
      </CButton>

      <CButton :loading="isLoading" :type="isDelete ? 'error' : 'primary'" @click="emit('confirm')">
        {{ confirmText ?? t('canvasUI.common.confirm') }}
      </CButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'

const { t } = useI18n()

interface Props {
  disableCancelWhenLoading?: boolean
  disableDenyWhenLoading?: boolean
  isLoading: boolean
  exitText?: string
  cancelText?: string
  confirmText?: string
  hasExit?: boolean
  isDelete?: boolean
  hasCancel?: boolean
}

withDefaults(defineProps<Props>(), {
  hasCancel: true,
  hasExit: true,
})

const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
  (e: 'exit'): void
}>()
</script>
